<template>
  <v-snackbar v-model="snackbar" color="warning" timeout="2000" top multi-line content-class="snackbar-content">
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" icon @click="snackbar = false" class="fixed-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'WarningInfo',

  components: {},

  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
  },

  data: () => ({}),

  computed: {
    message: {
      get() {
        return this.value
      },
      set(message) {
        this.$emit('input', message)
      },
    },
    snackbar: {
      get() {
        return this.value !== ''
      },
      set(snackbar) {
        if (!snackbar) {
          this.message = ''
        }
      },
    },
  },

  methods: {},
}
</script>

<style scoped>
.fixed-btn {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
